import axios from "axios";
import Pusher from "pusher-js";
// if (process.env.NODE_ENV === "development") {
// Pusher.logToConsole = true;
// }
const pusher = new Pusher(process.env.VUE_APP_PUSHER_APP_KEY, {
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        axios
          .post("broadcasting/auth", {
            socket_id: socketId,
            channel_name: channel.name,
          })
          .then((response) => {
            callback(false, response.data);
          })
          .catch((error) => {
            console.log("ECHO", error.response);
            callback(true, error);
          });
      },
    };
  },
  cluster: "eu",
  encrypted: true,
});

export default pusher;
